module.exports = __webpack_public_path__ + "img/halo_yellow.4774b545.png";